import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Hidden, Input } from '~/components/Form';

import { t } from '~/helpers';
import { GFE } from '~/constants/perfil';

import { Container } from './styles';

import { updateOperacaoAfericaoVeiculo } from '~/store/modules/operacaoafericaoveiculo/actions';
import { toast } from 'react-toastify';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { loading, find, params } = useSelector(
    (state) => state.operacaoafericaoveiculo
  );

  const { profile } = useSelector((state) => state.user);

  const initials = create ? data : { ...find, ...data };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === GFE) {
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  async function handleSubmit(param) {
    if (profile.gloperfilid === GFE) {
      toast.error('Usuário não tem permissão para alteração');
      return;
    }
    if (reference.current.getFieldValue('veic_em_afericao') === 'S') {
      toast.error('Veículo já está em aferição');
      return;
    }
    if (
      reference.current.getFieldValue('vedv_contador_permite') !== 'PERMITE'
    ) {
      toast.error('Usuário não tem permissão para alteração');
      return;
    }
    try {
      const schema = Yup.object().shape({
        veic_placa: Yup.string().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        orga_codigo: param.orga_codigo,
        unid_codigo: param.unid_codigo,
        veic_placa: param.veic_placa,
        veic_em_manutencao: param.veic_em_manutencao,
        veic_em_afericao: param.veic_em_afericao,
        vedv_contador: param.vedv_contador,
        vedv_contador_permite: param.vedv_contador_permite,
      };

      await dispatch(updateOperacaoAfericaoVeiculo(objSend, params));
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <Container>
      <>
        {loading ? (
          <div style={{ height: '14rem', width: '50rem' }}>
            <Spinner loading />
          </div>
        ) : (
          <>
            <div className="Container__Cabecalho">
              Incluir Veículo em Aferição:
            </div>
            <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>

              <Hidden name="orga_codigo" />
              <Hidden name="unid_codigo" />
              <Hidden name="veic_em_manutencao" />
              <Hidden name="veic_em_afericao" />
              <Hidden name="vedv_contador" />
              <Hidden name="vedv_contador_permite" />
              <div className="Container__Informacao">
                <Input name="veic_placa" label="Veículo" disabled="true" />
              </div>
            </Form>
          </>
        )}
      </>
    </Container>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
